import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { CompanyDefaultsSubTabs } from "../components/common/CompanyDefaultsSubTabs.tsx"
import { FormFieldRequirementsSettings } from "../components/form-field-requirements/FormFieldRequirementsSettings.tsx"

export default function SettingsFormFieldRequirementsPage() {
  useEffect(() => {
    generateDocumentTitle("Settings Required Information")
  }, [])

  return (
    <div className="flex-1 flex flex-col w-full">
      <CompanyDefaultsSubTabs />
      <FormFieldRequirementsSettings />
    </div>
  )
}
